/** @jsxImportSource @emotion/react */
import { ErrorContent } from 'fetcher';
import React from 'react';
import { Heading } from './Heading';
import { Icon, errorIcon } from './Icon';
import { Text } from './Text';
import { Wrapper } from './Wrapper';

type Props = ErrorContent;

export const Error: React.FC<Props> = ({ title, japanese, english }) => (
  <Wrapper data-cy-page-type="error" data-cy-page-id>
    <Icon icon={errorIcon} css={{ margin: '0 auto 32px' }} />
    <Heading css={{ marginBottom: '16px' }}>{title}</Heading>
    <Text
      dangerouslySetInnerHTML={{ __html: japanese }}
      css={{ marginBottom: '28px' }}
    />
    <Text dangerouslySetInnerHTML={{ __html: english }} />
  </Wrapper>
);
